import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        stack: css`
            white-space: pre-line;
        `,
        root: css`
            ${common.fullContainer};
            display: flex;
            flex-direction: column;
        `,
        accordion: css`
            width: 80%;
            align-self: center;
            margin-bottom: 50px;
        `,
    }
}

export default styles
